// Array of YouTube video data
const youtubeVideos = [
    {
        title: "Crisis Notes",
        videoId: "zgr2YPnwX-0" // Example video ID
    },
    {
        title: "Note Passing and Coalition Building",
        videoId: "29OsjJD3KSc" // Example video ID
    }
];
document.addEventListener('DOMContentLoaded', ()=>{
    const videoGrid = document.getElementById('video-grid');
    youtubeVideos.forEach((video)=>{
        // Create video card container
        const videoCard = document.createElement('div');
        videoCard.className = 'video-card'; // Tailwind classes for styling
        // Create video title
        const videoTitle = document.createElement('h3');
        videoTitle.textContent = video.title;
        // Create video wrapper for responsive iframe
        const videoWrapper = document.createElement('div');
        videoWrapper.className = 'video-wrapper';
        // Create iframe for YouTube embed
        const iframe = document.createElement('iframe');
        iframe.src = `https://www.youtube.com/embed/${video.videoId}`;
        iframe.allow = "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture";
        iframe.allowFullscreen = true;
        iframe.setAttribute('loading', 'lazy'); // Lazy load iframes for performance
        // Append iframe to wrapper
        videoWrapper.appendChild(iframe);
        // Create "Watch on YouTube" link
        const youtubeLink = document.createElement('a');
        youtubeLink.href = `https://www.youtube.com/watch?v=${video.videoId}`;
        youtubeLink.target = "_blank"; // Open in new tab
        youtubeLink.rel = "noopener noreferrer"; // Security best practice
        youtubeLink.className = 'video-link';
        youtubeLink.textContent = "Watch on YouTube";
        // Append all elements to the video card
        videoCard.appendChild(videoTitle);
        videoCard.appendChild(videoWrapper);
        videoCard.appendChild(youtubeLink);
        // Append video card to the grid
        videoGrid.appendChild(videoCard);
    });
});

//# sourceMappingURL=jamun101.276748a6.js.map
